import React from 'react';
import { ButtonTwoState } from './ButtonTwoState';

export function HideButton(props: React.ComponentProps<typeof ButtonTwoState>) {
    return (<ButtonTwoState
        {...props}
        icon='eye-crossed'
        dataTest={props.isActive ? 'offer-hidden-yes' : 'offer-hidden-no'}
        tooltipText={props.isActive ? 'Объявление скрыто' : 'Скрыть объявление'}
    />);
}
